import React, { FC, useEffect } from 'react';
import { Wrapper, AddNewType } from './styles';
import { Header, LayoutComponent } from './components';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'common/hooks/redux';
import { setAdminData } from 'applicaiton/store/reducers/Admins/AdminsSlice';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const UserAdd: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    return () => {
      dispatch(setAdminData(null));
    };
  }, []);

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />
      <AddNewType>{t('users.adding_new_admin')}</AddNewType>
      <LayoutComponent />
    </Wrapper>
  );
};

export default UserAdd;
